import React from "react";
import { Box, Button, Input, Switch, TextArea } from "@showitinc/showit-wc";

import AppConstants from "../../../../constants/AppConstants";
import AssetPreview from "../../shared/AssetPreview";
import MediaSelectHandler from "../../../../components/utils/MediaSelectHandler";
import { initFormatter } from "../../../../utils/PropertyFormatters";
import DocumentStore from "../../../../document/DocumentStore";
import { COMMANDS } from "../../../../document/commands";

const { WP_ELEMENT_FEATURED_IMAGE } = AppConstants;

const WP_FEATURED_IMAGE = "wp.type";
const IMAGE_CONTENT_DESCRIPTION = "content.desc";
const IMAGE_CONTENT_TITLE = "content.title";

const ElementPropertiesGraphic = ({ onPropUpdate, isLocked, element, elementId, block }) => {
  const _onWPUpdate = (propInfo) =>
    onPropUpdate({
      ...propInfo,
      value: propInfo.value ? WP_ELEMENT_FEATURED_IMAGE : null,
    });

  const _assetSelectionHandler = () =>
    MediaSelectHandler.selectMedia(elementId, element, { type: "image" });

  const _resizeToAspectRatio = () =>
    DocumentStore.dispatch({
      type: COMMANDS.RESIZE_TO_ASPECT_RATIO,
      payload: [element, elementId, aspectRatio],
    });

  const graphic = element.get("content", false);
  const aspectRatio = graphic.get("aspect_ratio", false);
  const isWP = block.get("wp", false);
  const title = graphic.get("title");
  const desc = graphic.get("desc", "");
  const isFI = element.getIn(["wp", "type"], false) === WP_ELEMENT_FEATURED_IMAGE;
  const isPlaceholder = graphic.get("key") === undefined;

  const { onChange } = initFormatter(onPropUpdate);
  const { onChange: onFeaturedToggle } = initFormatter(_onWPUpdate);

  return (
    <>
      <AssetPreview
        label="File"
        propName="content"
        disabled={isLocked}
        value={graphic}
        onSelect={_assetSelectionHandler}
        onChange={onPropUpdate}
      />
      <Box mx="3">
        <Button
          variant="outline"
          disabled={isLocked}
          fullWidth
          iconPrefix="galleryElement"
          iconSize="20"
          onSIClick={_assetSelectionHandler}
        >
          {isPlaceholder ? "Choose" : "Swap"} Image
        </Button>
      </Box>
      {!isPlaceholder && (
        <Box mx="3" mt="1">
          <Button
            variant="link"
            disabled={isLocked}
            fullWidth
            iconPrefix="imageReset"
            iconSize="20"
            onSIClick={_resizeToAspectRatio}
          >
            Reset
          </Button>
        </Box>
      )}
      {!isFI && (
        <>
          <Input
            disabled={isLocked}
            label="Title"
            longLabel
            onSIBeforeChange={onChange(IMAGE_CONTENT_TITLE, title)}
            onSIInput={onChange(IMAGE_CONTENT_TITLE, title, true)}
            placeholder="Enter an image title"
            value={title || ""}
          />
          <TextArea
            disabled={isLocked}
            label="Alt Text"
            longLabel
            resize
            onSIBeforeChange={onChange(IMAGE_CONTENT_DESCRIPTION, desc)}
            onSIInput={onChange(IMAGE_CONTENT_DESCRIPTION, desc, true)}
            placeholder="Enter your description"
            value={desc || ""}
          />
        </>
      )}
      {isWP && (
        <Switch
          checked={isFI}
          disabled={isLocked}
          label="WordPress Featured Image"
          onSIChange={onFeaturedToggle(WP_FEATURED_IMAGE, isFI)}
        />
      )}
    </>
  );
};

export default ElementPropertiesGraphic;
